export enum CallType {
    REGULAR = 'Regular',
    AGENT_LEG = 'AgentLeg',
    RESKILL_PROXY = 'ReskillProxy',
    CONSULT = 'Consult',
    PERSONAL_QUEUE = 'PersonalQueue',
    DIALER = 'Dialer',
    TAKE_OVER = 'TakeOver',
    NATURAL_CALLING = 'NaturalCalling',
    CONFERENCE = 'Conference'
  }